<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="visible"
    :show-close="false"
    width="624px">
    <div class="base-info-wrap">
      <img src="../../assets/image/upgrade-student-tip.png">
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleSave" :loading="handleLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { studentUpgrade } from '@/model/customer-manager-model'
export default {
  name: 'StudentUpgradeDialog',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      handleLoading: false,
      dialogTitle: '学生升级'
    }
  },
  methods: {
    handleSave () {
      this.handleLoading = true
      // 调用api
      studentUpgrade({orgid: this.userInfo.origanization}).then(res => {
        this.handleLoading = false
        if (res.result === 'true') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$emit('oprate-success')
        } else {
          this.$message.error('操作失败，请稍后再试')
        }
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.base-info-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 194px;
}
</style>



// WEBPACK FOOTER //
// src/views/class/StudentUpgradeDialog.vue